import { PeopleOutline } from "@material-ui/icons";
import { Grid, Paper, Typography } from "@mui/material";
import React from "react";

const AppDashBox = ({ icon, label, value = 0, color }) => {
  return (
    <Paper sx={{ height: 125, border: "1px solid #eee" }} elevation={0} >
      <Grid container height={"100%"} alignItems={"center"} p={4}>
        <Grid item xs={6} textAlign={"center"}>
          {icon || <PeopleOutline fontSize="large" color={color || "primary"} />}
        </Grid>
        <Grid item xs={6} textAlign={"center"}>
          <Grid item>
            <Typography variant="h6">{value || 0}</Typography>
          </Grid>
          <Grid item> {label || "Label"}</Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AppDashBox;
